import { _post, _get, _delete } from "./Axios";

export default class PenguranganApi {
  static get(id = null) {
    if (id == null) {
      return _get("masterdata/pengurangan");
    } else {
      return _get("masterdata/pengurangan/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("masterdata/pengurangan?" + params);
  }
  static post(data) {
    return _post("masterdata/pengurangan", data);
  }
  static update(id, data) {
    return _post("masterdata/pengurangan/" + id, data);
  }
  static delete(id) {
    return _delete("masterdata/pengurangan/" + id);
  }
}
